export const portalContadorBaseUrl = 'https://api.pdc.esistem.com.br';
//export const portalContadorBaseUrl = 'http://esistem.plataformadocontador.com.br';
//export const portalContadorBaseUrl = 'https://localhost:5001';